module.exports = __webpack_public_path__ + "img/PRINT_BOOK.FR-Slider_01.b37ddb19.jpg";